// ==============================================================
//placeholder改行
// ==============================================================
jQuery(function() {
    let e = document.getElementById("coment");
    let s = `・ペットは何匹まで飼えますか
・駐車場は空いていますか
・〇〇エリアの他の物件情報も知りたい`;
    e.placeholder = s;
});